import { render, staticRenderFns } from "./ConfiguratorForm.vue?vue&type=template&id=81f1af8e&"
import script from "./ConfiguratorForm.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports